// src/utils/permissionUtils.ts

export const hasPermission = (allowedRoles: string[]): boolean => {
  const role = localStorage.getItem("role"); // e.g. "OWNER", "User", "Subscriber"

  const storedPermissions = localStorage.getItem("permissions");
  const permissions: string[] = storedPermissions ? JSON.parse(storedPermissions) : [];
//console.log("permissions:::"+permissions)
//console.log("storedPermissions"+storedPermissions)
  // ✅ Allow if user role matches OR permissions overlap
  return allowedRoles.some((perm) => permissions.includes(perm));
};
